import { render, staticRenderFns } from "./afterSaleNoTable.vue?vue&type=template&id=dccdad56&scoped=true&"
import script from "./afterSaleNoTable.vue?vue&type=script&lang=js&"
export * from "./afterSaleNoTable.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleNoTable.vue?vue&type=style&index=0&id=dccdad56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccdad56",
  null
  
)

export default component.exports